import React, { useState } from "react";
import { Link } from "react-router-dom";
import { StyleSheet, css } from "aphrodite";

export default function MainProduct(){
    const [isButtonHover, setIsButtonHover] = useState(false);

    const styles = StyleSheet.create({

        mainContainerStyle: {
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            height: '30rem',
            textAlign: "center",
            alignItems: "center",
            justifyContent: 'space-evenly',
            backgroundColor: '#011a39',
            gap: '10px',
            padding:'10px 0'

        },
        imageStyle: {
            height: '15rem',
            borderRadius: '10px',
            "@media (min-width: 1024px)": {
                height: '20rem',       
            }
        },
        textContainer: {
            display: 'flex',
            flexDirection: 'column',
            textAlign: "center",
            justifyContent: 'center',
            gap: '10px',
            padding:'10px',
            alignItems: "center",
            "@media (min-width: 1024px)": {
                alignItems: "flex-start",
                width: '30%',
                height: '60%',       
            }
        },
        textStyle: {
            color: '#F0EFEC',
            textAlign: 'justify',
            fontFamily: "Montserrat",

        },
        titleStyle: {
            color: '#fec803',
            fontFamily: "Oswald",
            fontSize:'1.5rem',

            fontStyle: "bold",
        },
        buttonStyle: {
            fontFamily: "Oswald",
            fontSize:'1.5rem',
            display: "inline-block",
            cursor: "pointer",
            userSelect: "none",
            color: isButtonHover ? "#fec803":"#F0EFEC",
            backgroundColor: isButtonHover ? "#F0EFEC" : "#fec803",
            border: "none",
            padding:"0.52rem 4rem",
            margin: "1rem 0px 0.8rem",
            gridColumnStart: "1",
            gridColumnEnd: "4",
            gridRowStart: "3",
            borderRadius:'6px',
            transition:'0.3s'
        }
    })
    return(
        <>
            <div className={css(styles.mainContainerStyle)}>
                <img src="/resources/dumpTrailerDiseño.png" className={css(styles.imageStyle)}></img>
                <div className={css(styles.textContainer)}>
                    <div className={css(styles.titleStyle)}>Built for Toughness, Engineered for Precision</div>
                    <div className={css(styles.textStyle)}>Whether you're hauling heavy loads, navigating rugged terrain, or transporting valuable cargo, our trailers are designed to deliver unmatched durability and reliability, every mile of the way.</div>
                    <Link to="/products" className={css(styles.buttonStyle)} 
                        onMouseEnter={() => setIsButtonHover(true)} 
                        onMouseLeave={() => setIsButtonHover(false)}>
                        MORE PRODUCTS
                    </Link>
                </div>
            </div>
        </>
    )
}